module.exports = __webpack_public_path__ + "fonts/deposit-detail-guide-2.15261f90s.png";